// extracted by mini-css-extract-plugin
export var aiStarIcon = "_mg-2";
export var container = "_mg-4";
export var dismissButton = "_mg-3";
export var hasPaddingBottom = "_mg-6";
export var last = "_mg-e";
export var scrollbarThumb = "_mg-c";
export var scrollbarTrack = "_mg-b";
export var selected = "_mg-9";
export var spin = "_mg-1";
export var spinning = "_mg-0";
export var suggestionItem = "_mg-d";
export var suggestionsPanel = "_mg-5";
export var tonePill = "_mg-8";
export var tonesContainer = "_mg-7";
export var unselected = "_mg-a";